import { useLocale } from "@custom/schema";
import React from "react";
import { InformationModal } from "./InformationModal";
export function Header() {
    var logoMap = {
        en: "/logo-en.png",
        de: "/logo-de.png",
        fr: "/logo-fr.png"
    };
    var locale = useLocale();
    return /*#__PURE__*/ React.createElement("header", null, /*#__PURE__*/ React.createElement("nav", {
        className: "mx-auto flex items-start justify-between px-4 py-5 lg:p-[1.875rem]",
        "aria-label": "Global"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex lg:flex-1"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "#",
        className: "p-2.5 md:p-[1.125rem] bg-white"
    }, /*#__PURE__*/ React.createElement("img", {
        className: "w-[3.25rem] md:w-[4.875rem] h-auto",
        src: logoMap[locale],
        alt: "Heks logo"
    }))), /*#__PURE__*/ React.createElement(InformationModal, null)));
}
